export const BANNER_CAROUSEL_WIDGETS = {
    SHOW_BANNER_CAROUSEL_FOR_CATEGORY: 'showBannerForCategory',
    SHOW_BANNER_FOR_CATEGORY: 'showBannerForCategory'
};
